import { useState } from "react";
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from "../utils/axios";
import { useDispatch } from "react-redux";
import { setAwaitCourrierOrdersCount } from "../features/DeliveryOrdersCountSlice";

function useAwaitingCourier() {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [awaitorders, setAwaitOrders] = useState([])
    const [awaitOrdersLoading, setAwaitOrdersLoading] = useState(false);
    const [totalNbOfPage, setTotalNbOfPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const dispatch = useDispatch();

    const GetAwaitOrders = async (pageNb, dateFrom, dateTo, type) => {
        setAwaitOrdersLoading(true);
        await DeliveryPortalAxios.post('/AwaitCourier/GetOrders', {
                page: pageNb,
                pageSize: 10,
                dateFrom: dateFrom,
                dateTo: dateTo,
                type: type
            }
        ).then((res) => {
            setAwaitOrders(res.data.payload.orders);
            if(res.data.payload?.length === 0) {
                setTotalNbOfPage(0);
                setTotalCount(0);
            } else {
                setTotalNbOfPage(res.data.payload.pageCount);
                setTotalCount(res.data.payload?.totalOrdersCount);
                dispatch(setAwaitCourrierOrdersCount(res.data.payload?.totalOrdersCount))
            }

            setAwaitOrdersLoading(false);
        })
    }

    return {
        GetAwaitOrders,
        awaitorders,
        awaitOrdersLoading,
        totalNbOfPage,
        totalCount,
    }
}

export default useAwaitingCourier;